import { render, staticRenderFns } from "./peoManagement.vue?vue&type=template&id=47e27a52&scoped=true"
import script from "./peoManagement.vue?vue&type=script&lang=js"
export * from "./peoManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e27a52",
  null
  
)

export default component.exports